<template>
  <rest-page layout="tabbed" :fetch-endpoint="fetchEndpoint">
    <page-header :title="pageTitle" :breadcrumbs="breadcrumbs" v-if="model">
      <slot name="actions" slot="actions" />
    </page-header>

    <page-tabs :tabs="enabledTabs" v-if="model">
      <template #router>
        <router-view :campaign="model" />
      </template>
    </page-tabs>
  </rest-page>
</template>

<script>
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import RestPage from '@/common/components/rest/RestPage'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'CampaignLogPage',

  components: {
    RestPage,
    PageHeader,
    PageTabs
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url:
          'campaigns/' + this.$route.query.id + '?expand=qualification,trigger',
        handler: model => {
          this.model = model
        }
      })
    },

    pageTitle() {
      return this.model.title
    },

    breadcrumbs() {
      return [
        { label: this.$t('Campaigns_Breadcrumb_Campaigns') },
        {
          label: this.model.title,
          route: projectRoute({
            name: 'ViewCampaign',
            query: { id: this.$route.query.id }
          })
        },
        { label: 'Log' }
      ]
    },

    tabs() {
      return [
        {
          title: this.$t('Campaigns_Log_Tab_Executions'),
          route: projectRoute({
            name: 'CampaignExecutions',
            query: { id: this.$route.query.id }
          })
        },
        {
          title: this.$t('Campaigns_Log_Tab_Triggers'),
          route: projectRoute({
            name: 'CampaignTriggers',
            query: { id: this.$route.query.id }
          }),
          enabled: () => {
            return this.model.trigger
          }
        },
        {
          title: this.$t('Campaigns_Log_Tab_Qualifications'),
          route: projectRoute({
            name: 'CampaignQualifications',
            query: { id: this.$route.query.id }
          }),
          enabled: () => {
            return this.model.qualification
          }
        }
      ]
    },

    enabledTabs() {
      return this.tabs.filter(item => {
        if (item.enabled === undefined) {
          return true
        } else {
          return item.enabled()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/CampaignLogPage.vue